import { OctagonAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { isApiError } from '../api';
import { signingError } from '../lib/signingErrors';
import { SMARTCA_SETTINGS_URL } from '../lib/signingService';

/**
 * Why a registrar-signature request ("Ký SmartCA", "Gửi ký ngay") was refused, in plain
 * Vietnamese from the server's code: the failing checks as a list, the way to the SmartCA
 * settings when signing is off or not configured. The code and request id only behind "Chi tiết".
 */
export function SigningError({ error }: { error: unknown }) {
  const { t } = useTranslation('compliance');
  const api = isApiError(error) ? error : null;
  const v = signingError(api);
  const detail = [v.pendingCheck ? t('signature.error.pendingCheck', { count: v.pendingCheck }) : null, v.review ? t('signature.error.needsStaff', { count: v.review }) : null]
    .filter(Boolean)
    .join(', ');
  const title = t(`signature.error.${v.code}`, { detail, message: v.serverMessage ?? '' });
  return (
    <div className="flex gap-2 rounded-md border border-critical/30 bg-critical-soft p-3 text-sm text-foreground" role="alert" data-signing-error={v.code}>
      <OctagonAlert className="mt-0.5 size-4 shrink-0 text-critical" aria-hidden="true" />
      <div className="flex min-w-0 flex-col gap-1">
        <p className="break-words">
          {title}
          {v.settingsLink ? (
            <>
              {' — '}
              <Link to={SMARTCA_SETTINGS_URL} className="font-medium text-primary underline-offset-2 hover:underline">
                {t('signature.notice.open')}
              </Link>
            </>
          ) : null}
        </p>
        {v.reasons.length ? (
          <ul className="list-disc pl-5" data-signing-reasons>
            {v.reasons.map((r) => (
              <li key={r}>{r}</li>
            ))}
          </ul>
        ) : null}
        {api ? (
          <details className="text-xs text-muted-foreground">
            <summary className="cursor-pointer select-none">{t('signature.error.details')}</summary>
            {t('signature.error.meta', { code: api.code, requestId: api.requestId })}
          </details>
        ) : null}
      </div>
    </div>
  );
}
